import analytics from '../../../analytics'

export const facebookProviderId = 'graph.facebook.com'

const authDefault = {
  status: '',
  accessToken: '',
  expiresIn: ''
}

const profileDefault = {
  id: '',
  name: '',
  email: ''
}

export const facebookModule = {
  state: {
    authResponse: authDefault,
    profile: profileDefault,
    loading: false
  },
  getters: {
    facebookLoginEntry: state => {
      return { [facebookProviderId]: state.authResponse.accessToken }
    },
    facebookEmailAddress: state => {
      return state.profile.email
    },
    facebookName: state => {
      return state.profile.name
    },
    facebookSigninLoading: state => {
      return state.loading
    }
  },
  mutations: {
    setFacebookSigninLoading (state, facebookSigninLoading) {
      state.loading = facebookSigninLoading
    },
    /**
     * Update authentication response values
     */
    updateFacebookAuthResponse (state, response) {
      state.profile.id = response.authResponse.userID
      state.authResponse = response.authResponse

      console.log('Facebook Sign-In Success: %O', response)
    },

    /**
     * Update the Facebook profile details on profile retrieval
     */
    updateFacebookProfile (state, response) {
      state.profile.name = response.name
      state.profile.email = response.email

      console.log('Retrieved Facebook profile: %O', response)
    },

    /**
     * Failed Facebook Signin
     */
    onFacebookSignInError (state, response) {
      state.loading = false
      console.log('Facebook Sign-In authorization failed: ' + response)
    },

    /**
     * Facebook SignOut
     */
    onFacebookSignOut (state, response) {
      state.profile = profileDefault
      state.authResponse = authDefault

      console.log('Facebook Sign-Out Success')
    }
  },
  actions: {
    /**
     * Successful Facebook Sign-In
     */
    onFacebookSignInSuccess (context, response) {
      context.commit('updateFacebookAuthResponse', response)

      var start = analytics.currentTime()
      window.FB.api('/me?locale=en_US&fields=name,email', function (response) {
        var end = analytics.currentTime()
        analytics.time('API', 'signin-facebook', end - start, 'success')
        context.commit('updateFacebookProfile', response)
      })
    },

    /**
     * Action to sign out the currently signed in facebook account
     */
    facebookSignOut (context) {
      var start = analytics.currentTime()
      window.FB.logout((response) => {
        var end = analytics.currentTime()
        analytics.time('API', 'signout-facebook', end - start, 'success')
        context.commit('onFacebookSignOut', response)
      })
    },
    onLogin (context) {
      context.commit('setFacebookSigninLoading', false)
    }
  }
}

export default facebookModule



// WEBPACK FOOTER //
// ./src/store/auth/idp/facebook.js